import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../../../components/UI/Avatar";
import { Loader2 } from "lucide-react";
import { cn } from "../../../../utils/utils";

/**
 * Card gợi ý kết bạn — avatar + tên + "Có thể bạn quen" + 2 button Bỏ qua / Kết bạn.
 */
const SuggestionCard = ({
  avatar,
  name,
  subtitle = "Có thể bạn quen",
  onSkip,
  onAddFriend,
  pending = false,
  shopName,
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-3 flex flex-col gap-2.5 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-start gap-2.5">
        <Avatar className="h-10 w-10 shrink-0">
          <AvatarImage src={avatar} alt={name} />
          <AvatarFallback>{name?.charAt(0) || "?"}</AvatarFallback>
        </Avatar>
        <div className="min-w-0 flex-1">
          <div className="font-semibold text-[13px] text-gray-900 truncate">
            {name || "(Không tên)"}
          </div>
          <div className="text-[12px] text-gray-500 truncate">{subtitle}</div>
          {shopName && (
            <div className="text-[11px] text-gray-400 truncate mt-0.5">
              {shopName}
            </div>
          )}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <button
          onClick={onSkip}
          disabled={pending}
          className={cn(
            "h-8 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-700 text-[12px] font-medium transition-colors inline-flex items-center justify-center gap-1.5",
            pending && "opacity-60 cursor-not-allowed",
          )}
        >
          Bỏ qua
        </button>
        <button
          onClick={onAddFriend}
          disabled={pending}
          className={cn(
            "h-8 rounded-md bg-indigo-50 hover:bg-indigo-100 text-indigo-700 text-[12px] font-medium transition-colors inline-flex items-center justify-center gap-1.5",
            pending && "opacity-60 cursor-not-allowed",
          )}
        >
          {pending && <Loader2 size={12} className="animate-spin" />}
          Kết bạn
        </button>
      </div>
    </div>
  );
};

export default SuggestionCard;
